import { Close } from "@mui/icons-material"
import {
  Alert,
  Box,
  InputAdornment,
  InputBase,
  SxProps,
  Theme,
} from "@mui/material"
import IMask, { InputMask } from "imask"
import { useEffect, useRef, useState } from "react"
import SearchIcon from "../../../assets/svg/header-icons-pack/Search-icon.svg?react"
import { fadeIn, fadeOut } from "../PromotionModal/style"
import * as s from "./style"

type Props = {
  errorTitle?: string
  serErrorTitle?: (v: string) => void
  query: string
  setQuery: (v: string) => void
  style?: SxProps<Theme>
}

export default function SearchPhoneEmployees({
  errorTitle,
  serErrorTitle = () => {},
  query,
  setQuery,
  style,
}: Props) {
  const [fadeAnimation, setFadeAnimation] = useState(fadeIn)
  const [isErrorPopup, setIsErrorPopUp] = useState("")
  const inputStyle = { ...s.inputStyle, ...style }
  const inputRef = useRef<HTMLInputElement | null>(null)
  const maskRef = useRef<InputMask<any> | null>(null)

  useEffect(() => {
    if (inputRef.current) {
      const maskOptions = { mask: "+{7}(000)000-00-00" }
      maskRef.current = IMask(inputRef.current, maskOptions)
      maskRef.current.on("accept", () => setQuery(maskRef.current?.value || ""))
    }

    return () => {
      maskRef.current?.destroy()
    }
  }, [setQuery])

  useEffect(() => {
    if (maskRef.current && maskRef.current.value !== query) {
      maskRef.current.value = query
    }
  }, [query])

  useEffect(() => {
    const fadeId = setTimeout(() => {
      setFadeAnimation(fadeOut)
    }, 1000)

    const timerId = setTimeout(() => {
      serErrorTitle("")
      setIsErrorPopUp("")
      setFadeAnimation(fadeIn)
    }, 1100)

    return () => {
      clearTimeout(fadeId)
      clearTimeout(timerId)
    }
  }, [isErrorPopup, errorTitle])

  return (
    <Box sx={s.inputCont}>
      <InputBase
        id="promotion-input"
        inputRef={inputRef}
        placeholder="Номер телефона"
        value={query}
        sx={inputStyle}
        autoComplete="off"
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon color="var(--Schemes-Primary)" />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <Close
              onClick={() => setQuery("")}
              sx={s.clearInputStyle}
              style={{
                opacity: query ? "1" : "0",
                visibility: query ? "visible" : "hidden",
              }}
            />
          </InputAdornment>
        }
      />

      <Alert
        variant="filled"
        severity="error"
        sx={{
          ...s.alertStyle,
          display: errorTitle || isErrorPopup ? "flex" : "none",
          opacity: errorTitle || isErrorPopup ? 1 : 0,
          animation: `${fadeAnimation} 0.15s ease-in-out`,
        }}
      >
        {errorTitle ? errorTitle : isErrorPopup}
      </Alert>
    </Box>
  )
}
